import { useRef as a, useEffect as s, useCallback as d, useState as w } from "react";
const m = (e, r) => {
  const c = a(e), n = a(null);
  return s(() => (c.current = e, () => {
    n.current !== null && clearTimeout(n.current);
  }), [e]), d((...o) => {
    n.current && clearTimeout(n.current), n.current = setTimeout(() => {
      c.current(...o);
    }, r);
  }, [r]);
}, p = () => {
  const { history: e } = window;
  return {
    push: (n) => {
      const t = new URL(window.location.href), o = `${t.origin}${t.pathname}${t.search}${t.hash}/${n}`;
      e.pushState({}, "", o);
    },
    back: () => {
      e.back();
    }
  };
}, l = (e) => {
  s(() => {
    const r = () => {
      const t = "POP", { location: o } = window;
      e({ action: t, location: o });
    }, c = () => {
      const t = "PUSH", { location: o } = window;
      e({ action: t, location: o });
    }, n = () => {
      const t = "REPLACE", { location: o } = window;
      e({ action: t, location: o });
    };
    return window.addEventListener("popstate", r), window.addEventListener("pushstate", c), window.addEventListener("replacestate", n), () => {
      window.removeEventListener("popstate", r), window.removeEventListener("pushstate", c), window.removeEventListener("replacestate", n);
    };
  }, [e]);
}, v = ({ targetRef: e, eventList: r = [], handler: c = () => {
} }) => {
  s(() => {
    const n = (t) => {
      e.current && !e.current.contains(t.target) && c();
    };
    return Array.isArray(r) && r.map((t) => window.addEventListener(t, n)), () => {
      Array.isArray(r) && r.map((t) => window.removeEventListener(t, n));
    };
  }, [e, c, r]);
}, f = ({
  target: e,
  parent: r,
  callback: c,
  options: n
}) => {
  s(() => {
    const t = e.current, o = r?.current;
    if (!t) return () => {
    };
    const i = new IntersectionObserver(([u]) => {
      u.isIntersecting && c();
    }, {
      ...o ? { root: o } : {},
      threshold: 1,
      ...n
    });
    return i.observe(t), () => {
      i.unobserve(t);
    };
  }, [c, n, r, e]);
}, E = (e) => {
  const [r, c] = w(() => window.matchMedia(`(max-width: ${e}px)`).matches), n = a(null);
  return s(() => {
    const t = window.matchMedia(`(max-width: ${e}px)`);
    n.current = t;
    function o() {
      c(window.matchMedia(`(max-width: ${e}px)`).matches);
    }
    return n.current.addEventListener("change", o), () => {
      n.current?.removeEventListener("change", o);
    };
  }, [e]), r;
};
export {
  m as useDebounce,
  p as useHistory,
  l as useHistoryEvent,
  v as useInterectOutside,
  f as useIntersectionObserver,
  E as useMediaQuery
};
//# sourceMappingURL=index.js.map
